import styled from 'styled-components';
export var Section = styled.section.withConfig({
  displayName: "GroupBystyles__Section",
  componentId: "keen-query-creator__sc-1gpbp0x-0"
})(["&&&{display:flex;position:relative;}"]);
export var GroupSettings = styled.div.withConfig({
  displayName: "GroupBystyles__GroupSettings",
  componentId: "keen-query-creator__sc-1gpbp0x-1"
})(["&&&{margin-right:10px;margin-bottom:10px;}&&&[draggable='true'] .drag-handle{cursor:grabbing;}&&&:last-child{margin-right:0;}"]);
export var SortableContainer = styled.div.withConfig({
  displayName: "GroupBystyles__SortableContainer",
  componentId: "keen-query-creator__sc-1gpbp0x-2"
})(["&&&{display:flex;flex-wrap:wrap;}"]);